export default __webpack_public_path__ + "static/reflection-cac695544929542833002ffe7499a1c5.png";